import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'

import type { paths } from '../gen/tintin-search-service-schema'
import config from './req.config'

export type { paths as SearchPaths }

export const searchServiceReq = createFetchClient<paths>({
  ...config,
})

export const searchServiceQuery = createClient<paths>(searchServiceReq)
